// src/pages/Contacto.js
import React, { useState, useRef } from 'react';
import { Card, Button, Form, Col, Row, Container } from 'react-bootstrap';
import '../styles/Contacto.css';

const Contacto = () => {
  const [messageSent, setMessageSent] = useState(false);
  const formRef = useRef(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setMessageSent(true);
    formRef.current.reset(); // Restablecer el formulario
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">

        <Col md={12} className="d-flex flex-column">
          <Card className="info-card flex-fill">
            <Card.Body>
              <Card.Title>Horarios:</Card.Title>
              <Card.Text>
                Abierto de Lunes a Domingo las 24 horas
              </Card.Text>
            </Card.Body>
          </Card>
          <Card className="info-card mt-3 flex-fill">
            <Card.Body>
              <Card.Title>Domicilio:</Card.Title>
              <Card.Text>
                Manuel Acuña No. 2844-6<br />
                Colonia Providencia<br />
                CP 44670 Guadalajara, Jalisco
              </Card.Text>
            </Card.Body>
          </Card>
          <Card className="info-card mt-3 flex-fill">
            <Card.Body>
              <Card.Title>Teléfonos:</Card.Title>
              <Card.Text>
                33 3641-8271<br />
                33 3640-3049<br />
                33 3641-3877<br />
                33 3641-8968
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Contacto;
